import { Box, Button, List, ListItem, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../styles/pages/copywriter-searchresult.module.scss";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcTime,
  roleFinder,
} from "../../lib/functions/utils.lib";
import VideoPageFullModal from "../VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../VideoPages/pages/WatchVideoModal";

const SearchCard = (props) => {
  const { item } = props;
  const [type, setType] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index - 1);
    console.warn("index", index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const [openModal, setOpenModal] = useState(false);
  const [openModalTwo, setOpenModalTwo] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
  };
  const onOpenTwo = (id) => {
    setId(id);
    setOpenModalTwo(true);
  };
  const onCloseTwo = () => {
    setId();
    setOpenModalTwo(false);
  };

  function videoStatus(item) {
    if (
      item?.status === 0 &&
      item?.manager_decision === 0 &&
      item?.admin_decision === 0 &&
      item?.quality_team_decision === 0
    ) {
      return "Video pending Reviewing";
    } else if (
      item?.manager_decision !== 0 &&
      item?.quality_team_decision === 0
    ) {
      return "video Awaiting confirmation";
    } else if (item?.video_meta?.revision_requested_at === 1) {
      return "Metadata Revision Requested";
    } else if (item?.video_meta?.new_title === null && item?.status === 1) {
      return "Video Pending Titling";
    } else if (
      item?.video_meta?.copywrite_completed === 1 &&
      item?.published === 0
    ) {
      return "Video Pending Publication";
    } else {
      return null;
    }
  }

  function videoDate(item) {
    if (
      item?.status === 0 &&
      item?.manager_decision === 0 &&
      item?.admin_decision === 0 &&
      item?.quality_team_decision === 0
    ) {
      return `Since ${getUtcDate(item?.created_at)}${getUtcTime(
        item?.created_at
      )}`;
    } else if (
      item?.manager_decision !== 0 &&
      item?.quality_team_decision === 0
    ) {
      return `Since ${getUtcDate(
        item?.video_meta?.manager_updated_at
      )}${getUtcTime(item?.video_meta?.manager_updated_at)}`;
    } else if (item?.video_meta?.revision_requested_at === 1) {
      return `Since ${getUtcDate(
        item?.video_meta?.revision_requested_at
      )}${getUtcTime(item?.video_meta?.revision_requested_at)}`;
    } else if (item?.video_meta?.new_title === null && item?.status === 1) {
      return item?.status_changed_at
        ? `Since ${getUtcDate(item?.status_changed_at)}${getUtcTime(
            item?.status_changed_at
          )}`
        : null;
    } else if (item?.status === 2) {
      return item?.status_changed_at
        ? `Video Rejected on ${getUtcDate(item?.status_changed_at)}${getUtcTime(
            item?.status_changed_at
          )}`
        : null;
    } else if (item?.status === 6) {
      return item?.video_meta?.duplicate_marked_at
        ? `Video Flagged as Duplicate on ${getUtcDate(
            item?.video_meta?.duplicate_marked_at
          )}${getUtcTime(item?.video_meta?.duplicate_marked_at)}`
        : null;
    } else if (
      item?.video_meta?.copywrite_completed === 1 &&
      item?.published === 0
    ) {
      return `Since ${getUtcDate(
        item?.video_meta?.copywrite_completed_at
      )}${getUtcTime(item?.video_meta?.copywrite_completed_at)}`;
    } else if (item?.publshed === 1) {
      return item?.published_at
        ? `Video Published on ${getUtcDate(item?.published_at)}${getUtcTime(
            item?.published_at
          )}`
        : null;
    } else {
      return null;
    }
  }

  function videoColorType() {
    if (
      item?.status === 0 &&
      item?.manager_decision === 0 &&
      item?.admin_decision === 0 &&
      item?.quality_team_decision === 0
    ) {
      return setType("bgLightYellow");
    } else if (
      item?.manager_decision !== 0 &&
      item?.quality_team_decision === 0
    ) {
      return setType("bgLightGray");
    } else if (item?.video_meta?.revision_requested_at === 1) {
      return setType("bgLightGreen");
    } else if (item?.video_meta?.new_title === null && item?.status === 1) {
      return setType("bgLightGreen");
    } else if (
      item?.video_meta?.copywrite_completed === 1 &&
      item?.published === 0
    ) {
      return setType("");
    } else if (item?.status === 2) {
      return setType("bgLightRed");
    } else if (item?.status === 6) {
      return setType("bgDarkGray");
    } else if (item?.publshed === 1) {
      return setType("");
    } else {
      return null;
    }
  }

  useEffect(() => {
    videoColorType();
  }, []);

  return (
    <Stack
      direction="row"
      className={`${styles.searchCard} ${
        props?.hoveredIndex === props?.id ? `${styles.hover}` : ""
      }`}
      onMouseEnter={() => props?.handleMouseEnter(props?.id)}
      onMouseLeave={props?.handleMouseLeave}
    >
      {/* <Button > */}
      <Box className={styles.srchleftBox}>
        <figure onClick={() => onOpenTwo(props?.vsidText)}>
          <img
            src={concatHostAndImagePath(props?.figImg)}
            width={100}
            height={63}
            alt="image"
          />
        </figure>
      </Box>

      {/* </Button> */}

      <Box className={styles.srchrightBox}>
        <List>
          <ListItem>
            <Typography
              variant="caption"
              onClick={() => onOpen(props?.vsidText)}
            >
              VSID:
            </Typography>
            <Typography variant="body1" onClick={() => onOpen(props?.vsidText)}>
              {props?.vsidText}
            </Typography>
          </ListItem>
          <ListItem>
            <Typography variant="caption">Submission Date:</Typography>
            <Typography variant="body1">{props?.submissionDate}</Typography>
          </ListItem>
          <ListItem className={styles.submitterName}>
            <Typography variant="caption">Submitter Name:</Typography>
            <Typography variant="body1">{props?.submitterName}</Typography>
          </ListItem>
          <ListItem>
            <Typography variant="caption">Email Address:</Typography>
            <Typography variant="body1">{props?.emailAddress}</Typography>
          </ListItem>
          <ListItem>
            <Typography variant="caption">Acquisitor:</Typography>
            <Typography variant="body1">
              {props?.user?.name}
              {props?.user?.last_name}{" "}
              <span className={styles.partner}>
                ({roleFinder(props?.user?.role_id)})
              </span>
            </Typography>
          </ListItem>
        </List>
        {videoStatus(item) && videoDate(item) ? (
          <Box
            className={`${
              type === "bgLightGreen"
                ? `${styles.bgLightGreen} ${styles.srchStatus}`
                : type === "bgLightYellow"
                ? `${styles.bgLightYellow} ${styles.srchStatus}`
                : type === "bgLightGray"
                ? `${styles.bgLightGray} ${styles.srchStatus}`
                : type === "bgLightRed"
                ? `${styles.bgLightRed} ${styles.srchStatus}`
                : type === "bgDarkGray"
                ? `${styles.bgDarkGray} ${styles.srchStatus}`
                : styles.srchStatus
            }`}
          >
            <Typography variant="body2">{videoStatus(item)}</Typography>
            <Typography variant="body2">{videoDate(item)}</Typography>
          </Box>
        ) : (
          ""
        )}
      </Box>
      <VideoPageFullModal
        onClose={onClose}
        open={openModal}
        id={props?.vsidText}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="videoPageModal"
      />
      <WatchVideoModal
        onClose={onCloseTwo}
        open={openModalTwo}
        id={props?.vsidText}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="videoPageModal"
      />
    </Stack>
  );
};

export default SearchCard;
